export const GET_PRODUCTS_DATA_REQUEST ="GET_PRODUCTS_DATA_REQUEST";
export const GET_PRODUCTS_DATA_SUCCESS ="GET_PRODUCTS_DATA_SUCCESS";
export const GET_PRODUCTS_DATA_FAILURE ="GET_PRODUCTS_DATA_FAILURE";